module.exports = __webpack_public_path__ + "static/img/foot-logo-new.bc7fa00.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/foot-logo-new.png
// module id = +bjb
// module chunks = 1